import { useRef, useState, useEffect } from 'react';

// Speed of the visual "thinking" pulse, in milliseconds per step.
const PROCESSING_PULSE_SPEED = 320;

/**
 * Drives the visual "thinking" pulse during the ``thinking`` voice state.
 *
 * NOTE: This hook used to also emit an oscillator "tick" sound while processing.
 * That audible ticking was removed on request — only the silent pulse value that
 * powers the on-screen animation (via VoiceOverlay) remains. The hook keeps its
 * name and return shape so callers do not need to change.
 */
export default function useProcessingSound(voiceState) {
  const intervalRef = useRef(null);
  const [processingPulse, setProcessingPulse] = useState(0);

  useEffect(() => {
    if (voiceState === 'thinking') {
      let step = 0;
      intervalRef.current = setInterval(() => {
        step = (step + 1) % 8;
        setProcessingPulse(step);
      }, PROCESSING_PULSE_SPEED);
    } else if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setProcessingPulse(0);
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [voiceState]);

  return { processingPulse };
}
